const ArrowLeft = ({ color = "#7A7A83" }) => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.32019 8.33366L1.57611 5.58958C1.25067 5.26414 1.25067 4.73651 1.57611 4.41107L4.32019 1.66699"
      stroke="#7A7A83"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default ArrowLeft
